import { render, staticRenderFns } from "./SettingRestaurant.vue?vue&type=template&id=479c8960&scoped=true"
import script from "./SettingRestaurant.vue?vue&type=script&lang=js"
export * from "./SettingRestaurant.vue?vue&type=script&lang=js"
import style0 from "./SettingRestaurant.vue?vue&type=style&index=0&id=479c8960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479c8960",
  null
  
)

export default component.exports